import Multiselect from 'vue-multiselect';
import '../scss/_vue-multiselect.scss';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default Multiselect;



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/vue-multiselect.js